module.exports = __webpack_public_path__ + "img/course_Image_five.a0e27c62.png";